export const primaryLight = '#36c697';
export const primary1000 = '#00c896';
export const primary800 = '#85e5cd';
export const primary200 = '#ccf4ea';
export const primary100 = '#e5f9f4';
export const primaryText = '#072A48';


export const secondaryText = '#003f76';
export const secondaryBG = '#F8F9FF';
export const secondary1000alpha = '#194979';
export const secondary1000 = '#0d3f72';
export const secondary900 = '#5c7d98';
export const secondary800 = '#3d658e';
export const secondary400 = '#95afc8';
export const secondary300 = '#cfd9e3';
export const secondary200 = '#e2e8ee';
export const secondary100 = '#eef1f5';
export const secondary50 = '#f7f9fa';
export const secondary25 = '#fcfcfc';
export const secondary0 = '#ffffff';

export const accentOne1000 = '#00c896';
export const accentOne800 = '#85e5cd';
export const accentOne200 = '#ccf4ea';
export const accentOne100 = '#e5f9f4';

export const accentTwo1000 = '#fda633';
export const accentTwo800 = '#fedbad';
export const accentTwo200 = '#feeed6';
export const accentTwo100 = '#fef6ea';

export const accentThree1000 = '#ff5d5d';
export const accentThree800 = '#fd9c9c';
export const accentThree200 = '#fadada';
export const accentThree100 = '#fae9e9';

// Action state colors
export const primaryHoverBG = '#0ab58b';
export const primaryPressedBG = '#1a9879';
export const primaryCTAHoverBG = '#d68d29';
export const primaryCTAPressedBG = '#c18025';
export const secondaryHoverBG = primary100;
export const secondaryPressedBG = primary200;
export const accent3HoverBG = '#eb5353';
export const accent3PressedBG = '#cd4646';
export const deleteHoverBG = accentThree100;
export const deletePressedBG = accentThree200;
export const disabledText = '#a9bbca';
export const disabledBG = secondary100;
export const disabledSecondaryBG = secondary0;
export const disabledBorder = secondary200;
export const disabledLight = '#dbe1e7';
export const inactiveText = '#778899';

// Grapg & bars
export const blueberry = '#3e72ff';
export const caribbeanGreen = '#00c896';
export const mellowApricot = '#febd6a';
export const frenchPink = '#ff6ea7';
export const electricLavender = '#f3c3ff';
export const electricBlue = '#76f2ff';
export const floral = '#ab76ff';
export const periwinkle = '#c3d5ff';
export const GRAPH_AND_CHART_COLORS = [
  blueberry, caribbeanGreen, mellowApricot,
  frenchPink, electricLavender, electricBlue, floral, periwinkle,
];

// Other colors
export const interested = '#3e72ff';
export const bounced = '#c1054a';
export const markAsFinished = '#9a9dca';
export const uncategorized = '#9a9dca';
export const notInterested = '#ff508e';
export const notNow = '#ffb73e';
export const blacklisted = secondaryText;
export const sponsorship = '#c16aff';
export const transparent = 'transparent';
export const backdrop = '#022141';
export const deliveryStatusBadge = '#778899';

// Status Badge colors
export const erroredBadge = '#FF6EA7';
export const completedBadge = '#2C80FF';
export const inactiveBadge = '#778899';
export const activeBadge = '#00C896';

// Table
export const tableHead = '#65849E';
export const tableBody = '#072A48';

export const timlineRunInfo = '#5C7D98';
export const timelineStepRow = '#FAFBFC';


// Greys
export const grey600 = '#78838F';
export const grey700 = '#4D545C';
